module.exports = __webpack_public_path__ + "static/img/888.7b96b601.png";